/**
 * Mix-Match-Save bundle picker for smile cart recommendations.
 */
(function () {
  'use strict';

  var MIX_MATCH_HANDLE = 'mix-match-save';
  var productCache = {};

  var rootUrl = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
  var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';

  function getDrawer() {
    return document.getElementById('drawer-cart');
  }

  function lockScrollTo(element) {
    if (!element) return;
    window.dispatchEvent(
      new CustomEvent('theme:scroll:lock', {
        bubbles: true,
        detail: element,
      })
    );
  }

  function unlockScrollAndRestoreDrawer() {
    window.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));

    var drawer = getDrawer();
    if (!drawer || !drawer.classList.contains('drawer--visible')) return;

    var drawerScrolls = drawer.querySelector('[data-drawer-scrolls]');
    if (drawerScrolls) {
      drawerScrolls.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));
    }
  }

  function getModal() {
    return document.querySelector('[data-smile-mix-match-modal]');
  }

  function getFlavors() {
    var el = document.querySelector('[data-smile-mix-match-flavors]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function formatMoney(cents) {
    if (window.SmileCart && typeof window.SmileCart.formatMoney === 'function') {
      return window.SmileCart.formatMoney(cents);
    }
    var amount = (Number(cents) / 100).toFixed(2);
    return '₹' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function parsePackSize(title) {
    var match = String(title || '').match(/(\d+)/);
    return match ? parseInt(match[1], 10) : 0;
  }

  function sortVariantsByPack(variants) {
    return variants.slice().sort(function (a, b) {
      return parsePackSize(a.title) - parsePackSize(b.title);
    });
  }

  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    var url = rootUrl.replace(/\/?$/, '/') + 'products/' + handle + '.js';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Product not found');
        return r.json();
      })
      .then(function (product) {
        productCache[handle] = product;
        return product;
      });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getModalCopy() {
    var modal = getModal();
    return {
      submit: (modal && modal.dataset.submitLabel) || 'Add to cart 👈',
      pickHint: (modal && modal.dataset.pickHint) || 'Pick {{ current }} of {{ total }} tubes',
      pickComplete: (modal && modal.dataset.pickComplete) || 'Perfect — ready to add!',
    };
  }

  function formatPickHint(template, current, total) {
    return String(template)
      .replace(/\{\{\s*current\s*\}\}/g, String(current))
      .replace(/\{\{\s*total\s*\}\}/g, String(total));
  }

  function buildPackHtml(variants) {
    var sorted = sortVariantsByPack(variants).filter(function (variant) {
      return variant.available && parsePackSize(variant.title) > 0;
    });

    var defaultIndex = 0;
    for (var d = 0; d < sorted.length; d++) {
      if (parsePackSize(sorted[d].title) === 3) {
        defaultIndex = d;
        break;
      }
    }

    var html =
      '<section class="smile-mms__section">' +
      '<h4 class="smile-mms__section-title">Bundle and Save</h4>' +
      '<div class="smile-mms__packs">';

    sorted.forEach(function (variant, index) {
      var pack = parsePackSize(variant.title);
      var perTube = pack > 0 ? Math.round(variant.price / pack) : variant.price;
      var compare = variant.compare_at_price || 0;
      var isLast = index === sorted.length - 1;
      var isDefault = index === defaultIndex;
      var checked = isDefault ? ' checked' : '';
      var metaActive = isDefault ? ' is-active' : '';

      html +=
        '<label class="smile-mms__pack' +
        (isLast ? ' smile-mms__pack--best' : '') +
        '">' +
        '<input type="radio" name="smile-mix-pack" value="' +
        variant.id +
        '" data-pack-size="' +
        pack +
        '" data-price="' +
        variant.price +
        '" data-compare="' +
        compare +
        '"' +
        checked +
        '>' +
        '<span class="smile-mms__pack-face">' +
        (isLast ? '<span class="smile-mms__pack-badge">Best value</span>' : '') +
        '<span class="smile-mms__pack-name">' +
        escapeHtml(variant.title) +
        '</span>' +
        '<span class="smile-mms__pack-meta' +
        metaActive +
        '">' +
        formatMoney(perTube) +
        ' / tube</span>' +
        '<span class="smile-mms__pack-prices">' +
        (compare > variant.price
          ? '<span class="smile-mms__pack-compare">' + formatMoney(compare) + '</span>'
          : '') +
        '<span class="smile-mms__pack-price">' +
        formatMoney(variant.price) +
        '</span></span></span></label>';
    });

    html +=
      '</div>' +
      '<p class="smile-mms__pick-hint" data-smile-mix-pick-hint></p>' +
      '</section>';
    return html;
  }

  function buildFlavorsHtml(flavors) {
    var html =
      '<section class="smile-mms__section">' +
      '<h4 class="smile-mms__section-title">Flavour</h4>' +
      '<div class="smile-mms__flavour-list">';

    flavors.forEach(function (flavor) {
      html +=
        '<article class="smile-rec-card smile-mms__flavour-card" data-flavor-key="' +
        escapeHtml(flavor.key) +
        '">' +
        '<div class="smile-rec-card__media">' +
        '<img class="smile-rec-card__img" src="' +
        escapeHtml(flavor.image) +
        '" alt="' +
        escapeHtml(flavor.title) +
        '" width="72" height="72" loading="lazy">' +
        '</div>' +
        '<div class="smile-rec-card__body">' +
        '<h4 class="smile-rec-card__title">' +
        escapeHtml(flavor.title) +
        '</h4>' +
        '<p class="smile-mms__flavour-desc">' +
        escapeHtml(flavor.description) +
        '</p>' +
        '<div class="smile-qty">' +
        '<button type="button" class="smile-qty__btn smile-qty__btn--minus" data-qty-minus aria-label="Decrease ' +
        escapeHtml(flavor.title) +
        '">−</button>' +
        '<input type="number" class="smile-qty__input" readonly min="0" value="0" data-flavor-input="' +
        escapeHtml(flavor.key) +
        '" aria-label="' +
        escapeHtml(flavor.key) +
        ' quantity">' +
        '<button type="button" class="smile-qty__btn smile-qty__btn--plus" data-qty-plus aria-label="Increase ' +
        escapeHtml(flavor.title) +
        '">+</button></div></div></article>';
    });

    html += '</div></section>';
    return html;
  }

  function buildFooterHtml() {
    var copy = getModalCopy();
    return (
      '<footer class="smile-cart__footer smile-mms__footer">' +
      '<div class="smile-mms__totals">' +
      '<span class="smile-mms__total-compare" data-smile-mix-compare hidden></span>' +
      '<span class="smile-mms__total-price" data-smile-mix-price></span>' +
      '</div>' +
      '<button type="button" class="smile-cart__checkout-btn smile-mms__submit" data-smile-mix-submit disabled>' +
      escapeHtml(copy.submit) +
      '</button></footer>'
    );
  }

  function getState(scrollRoot) {
    var packInput = scrollRoot.querySelector('input[name="smile-mix-pack"]:checked');
    var packLimit = packInput ? Number(packInput.dataset.packSize || 0) : 0;
    var variantId = packInput ? Number(packInput.value) : 0;
    var price = packInput ? Number(packInput.dataset.price || 0) : 0;
    var compare = packInput ? Number(packInput.dataset.compare || 0) : 0;

    var quantities = {};
    var total = 0;
    scrollRoot.querySelectorAll('[data-flavor-input]').forEach(function (input) {
      var key = input.dataset.flavorInput;
      var qty = Number(input.value || 0);
      quantities[key] = qty;
      total += qty;
    });

    return {
      packLimit: packLimit,
      variantId: variantId,
      price: price,
      compare: compare,
      quantities: quantities,
      total: total,
    };
  }

  function setDefaultFlavours(scrollRoot, pack) {
    scrollRoot.querySelectorAll('[data-flavor-input]').forEach(function (input) {
      input.value = 0;
      var key = input.dataset.flavorInput;

      if (pack === 2) {
        if (key === 'Farm Mint') input.value = 1;
        if (key === 'Forest Essence') input.value = 1;
      } else if (pack === 3) {
        if (key === 'Farm Mint') input.value = 1;
        if (key === 'Forest Essence') input.value = 1;
        if (key === 'Active Black') input.value = 1;
      } else if (pack === 5) {
        if (key === 'Farm Mint') input.value = 2;
        if (key === 'Forest Essence') input.value = 2;
        if (key === 'Active Black') input.value = 1;
      }
    });
  }

  function updateUi(scrollRoot, footerRoot) {
    var state = getState(scrollRoot);
    var copy = getModalCopy();
    var compareEl = footerRoot.querySelector('[data-smile-mix-compare]');
    var priceEl = footerRoot.querySelector('[data-smile-mix-price]');
    var submit = footerRoot.querySelector('[data-smile-mix-submit]');
    var hintEl = scrollRoot.querySelector('[data-smile-mix-pick-hint]');

    if (compareEl) {
      if (state.compare > state.price) {
        compareEl.textContent = formatMoney(state.compare);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
        compareEl.textContent = '';
      }
    }

    if (priceEl) priceEl.textContent = formatMoney(state.price);

    scrollRoot.querySelectorAll('.smile-mms__pack-meta').forEach(function (el) {
      el.classList.remove('is-active');
    });
    var checked = scrollRoot.querySelector('input[name="smile-mix-pack"]:checked');
    if (checked) {
      var activePack = checked.closest('.smile-mms__pack');
      if (activePack) {
        var meta = activePack.querySelector('.smile-mms__pack-meta');
        if (meta) meta.classList.add('is-active');
      }
    }

    var atLimit = state.total >= state.packLimit;
    scrollRoot.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
      btn.disabled = atLimit;
    });
    scrollRoot.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
      var input = btn.nextElementSibling;
      btn.disabled = !input || Number(input.value) <= 0;
    });

    if (hintEl) {
      hintEl.textContent = formatPickHint(copy.pickHint, state.total, state.packLimit);
      hintEl.classList.toggle('is-complete', state.total === state.packLimit && state.packLimit > 0);
      hintEl.classList.toggle(
        'is-error',
        state.total > 0 && state.total < state.packLimit && state.packLimit > 0
      );
      if (state.total === state.packLimit && state.packLimit > 0) {
        hintEl.textContent = copy.pickComplete;
      }
    }

    if (submit) {
      var valid = state.packLimit > 0 && state.total === state.packLimit && state.variantId;
      submit.disabled = !valid;
    }
  }

  function bindContentEvents(modal, scrollRoot, footerRoot, onSuccess) {
    scrollRoot.addEventListener('change', function (e) {
      if (e.target.matches('input[name="smile-mix-pack"]')) {
        var pack = Number(e.target.dataset.packSize || 0);
        setDefaultFlavours(scrollRoot, pack);
        updateUi(scrollRoot, footerRoot);
      }
    });

    scrollRoot.addEventListener('click', function (e) {
      var plus = e.target.closest('[data-qty-plus]');
      var minus = e.target.closest('[data-qty-minus]');
      if (!plus && !minus) return;

      var state = getState(scrollRoot);
      var row = e.target.closest('[data-flavor-key]');
      if (!row) return;
      var input = row.querySelector('[data-flavor-input]');
      if (!input) return;

      if (plus && state.total < state.packLimit) {
        input.value = Number(input.value || 0) + 1;
      }
      if (minus) {
        input.value = Math.max(0, Number(input.value || 0) - 1);
      }
      updateUi(scrollRoot, footerRoot);
    });

    var submit = footerRoot.querySelector('[data-smile-mix-submit]');
    if (submit) {
      submit.addEventListener('click', function () {
        var state = getState(scrollRoot);
        if (state.packLimit < 1 || state.total !== state.packLimit || !state.variantId) return;

        submit.disabled = true;
        submit.classList.add('is-loading');

        var properties = {};
        getFlavors().forEach(function (flavor) {
          properties[flavor.key] = String(state.quantities[flavor.key] || 0);
        });

        fetch(cartUrl + '/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: state.variantId,
                quantity: 1,
                properties: {
                  ...properties,
                  _source: "Cart"
                },
              },
            ],
          }),
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (j) { throw j; });
            return r.json();
          })
          .then(function () {
            closeModal();
            if (typeof onSuccess === 'function') onSuccess();
          })
          .catch(function (err) {
            var errorEl = modal.querySelector('[data-smile-mix-match-error]');
            if (errorEl) {
              errorEl.textContent =
                (err && err.description) || (err && err.message) || 'Could not add to cart';
              errorEl.hidden = false;
            }
          })
          .finally(function () {
            submit.classList.remove('is-loading');
            updateUi(scrollRoot, footerRoot);
          });
      });
    }

    var initialPack = getState(scrollRoot).packLimit;
    if (initialPack) setDefaultFlavours(scrollRoot, initialPack);
    updateUi(scrollRoot, footerRoot);
  }

  function openModal(card, onSuccess) {
    var modal = getModal();
    if (!modal) return;

    var handle = card.dataset.productHandle || MIX_MATCH_HANDLE;
    var loading = modal.querySelector('[data-smile-mix-match-loading]');
    var scroll = modal.querySelector('[data-smile-mix-match-scroll]');
    var footerSlot = modal.querySelector('[data-smile-mix-match-footer]');
    var errorEl = modal.querySelector('[data-smile-mix-match-error]');

    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('smile-mix-match-open');

    var scrollBody = modal.querySelector('[data-smile-mix-match-body]');
    lockScrollTo(scrollBody);

    if (loading) loading.hidden = false;
    if (scroll) {
      scroll.hidden = true;
      scroll.innerHTML = '';
    }
    if (footerSlot) {
      footerSlot.hidden = true;
      footerSlot.innerHTML = '';
    }

    fetchProduct(handle)
      .then(function (product) {
        var flavors = getFlavors();
        var variants = product.variants || [];
        if (!variants.length) throw new Error('No packs available');

        if (scroll && footerSlot) {
          scroll.innerHTML = buildPackHtml(variants) + buildFlavorsHtml(flavors);
          footerSlot.innerHTML = buildFooterHtml();
          scroll.hidden = false;
          footerSlot.hidden = false;
          bindContentEvents(modal, scroll, footerSlot, onSuccess);
        }
      })
      .catch(function (err) {
        if (errorEl) {
          errorEl.textContent = (err && err.message) || 'Unable to load product';
          errorEl.hidden = false;
        }
      })
      .finally(function () {
        if (loading) loading.hidden = true;
      });
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('smile-mix-match-open');
    unlockScrollAndRestoreDrawer();

    var scroll = modal.querySelector('[data-smile-mix-match-scroll]');
    var footerSlot = modal.querySelector('[data-smile-mix-match-footer]');
    if (scroll) scroll.innerHTML = '';
    if (footerSlot) footerSlot.innerHTML = '';
  }

  function bindModalClose() {
    var modal = getModal();
    if (!modal || modal.dataset.smileMixMatchBound === 'true') return;
    modal.dataset.smileMixMatchBound = 'true';

    modal.querySelectorAll('[data-smile-mix-match-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });
  }

  function bindCard(card, onSuccess) {
    if (!card || card.dataset.mixMatchSave !== 'true' || card.dataset.smileMixMatchBound === 'true') {
      return;
    }
    card.dataset.smileMixMatchBound = 'true';

    var btn = card.querySelector('[data-smile-rec-add]');
    if (!btn) return;

    btn.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (btn.classList.contains('loading')) return;
        openModal(card, onSuccess);
      },
      true
    );
  }

  function init() {
    bindModalClose();
  }

  window.SmileCartMixMatch = {
    handle: MIX_MATCH_HANDLE,
    bindCard: bindCard,
    open: openModal,
    close: closeModal,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
